<template>
  <svg viewBox="0 0 48 48" fill="currentColor">
    <path
      d="M41 32C38 31 36 30 32.5 28 35 23 36 20 37 16H26V12H39V9H26V3H21C20 3 20 4 20 4V9H7V12H20V16H8V18H30A37 37 90 0127 25C19 21.5 12 21 8 23 6 24 3 26 2 29 0 37 5 42 12 43 20 43 26 38 29.5 33 38 38 47 43 48 43V34S47 34 41 32ZM12 39C8 39 5 37 4 34 3 30 8 26 12 26 15 26 19 27 24 30 20 35 18 38 12 39Z"
    />
  </svg>
</template>
